import { Pipe, PipeTransform } from '@angular/core';
import { GroupLookupItem, LookupItem, NumericLookupItem, StringGroupLookupItem, StringLookupItem } from '@models/lookup';
import { getDisplayText } from '@shared/helpers/functions/helpers';

type AllowedTypes = LookupItem | NumericLookupItem | string | number | StringLookupItem | GroupLookupItem | StringGroupLookupItem;
@Pipe({
    name: 'displayText',
    standalone: false,
})
export class DisplayTextPipe implements PipeTransform {
    transform(item: AllowedTypes | AllowedTypes[]): string | null | undefined {
        if (Array.isArray(item)) {
            return item.map((x) => getDisplayText(x)).join(', ');
        }
        return getDisplayText(item);
    }
}
